module.exports = __webpack_public_path__ + "static/media/banner1.d6730c15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/fehlmann/images/banner1.jpg
// module id = 486
// module chunks = 0